import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import SupportLink from '@components/SupportLink';

import InfoLink from './InfoLink';

import style from './Info.scss';

const cn = bemCssModules(style, 'Info');

const Info: CustomFC = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(null, [className])}>
      <h2 className={cn('title', ['h2'])}>{t('public.information')}</h2>
      {CONST.infoLinks.map(({ text, link }) => (
        <InfoLink key={link} link={link} text={text} />
      ))}
      <div>
        <SupportLink href="mailto:support@mercuryo.io" className={cn('support', ['h1'])} />
      </div>
      <p>{t('profile.typically_reply')}</p>
    </div>
  );
};

export default Info;
